import { Component, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { FormsComponent } from '../forms/forms.component';
import { CommunicationService } from '../../../shared/services/communication.service';
import { CurrentSiteService } from '../../../shared/services/current-site.service';
import { DataCollectionService } from '../../../shared/services/data-collection.service';
import { DeleteOnConfirmDialogService } from '../../../shared/services/delete-on-confirm-dialog.service';
import { FormBuilderService } from '../../../shared/services/form-builder.service';
import { FormInstanceService } from '../../../shared/services/form-instance.service';
import { AccessibilityHelper } from '../../../shared/accessibility.helper';

@Component({
    selector: 'app-forms-html-only',
    //imports: [],
    templateUrl: '../forms/forms.component.html', //'./forms-html-only.component.html',
    styleUrls: ['./forms-html-only.component.scss', '../forms/forms.component.scss'],
    standalone: false
})
export class FormsHtmlOnlyComponent extends FormsComponent {
    // Constructor.
    public constructor(formBuilderService: FormBuilderService,
        formInstanceService: FormInstanceService,
        dataCollectionService: DataCollectionService,
        currentSiteService: CurrentSiteService,
        activeRoute: ActivatedRoute,
        route: ActivatedRoute,
        router: Router,
        dialog: MatDialog,
        communicationService: CommunicationService,
        deleteOnConfirmDialogService: DeleteOnConfirmDialogService,
        titleService: Title,
        elForBaseClass: ElementRef)
    {
        super(formBuilderService,
        formInstanceService,
        dataCollectionService,
        currentSiteService,
        activeRoute,
        route,
        router,
        dialog,
        communicationService,
        deleteOnConfirmDialogService,
        titleService,
        elForBaseClass);
    }

    // Override base class method doOnEdit();
    public doOnEdit(eventData: any): void {
        let id = eventData.item.id;
        let url = `/site/${this.site.id}/design-html-edit-only/${id}`;
        let eventType = AccessibilityHelper.deduceEventType(eventData.originalEvent);
        this.router.navigateByUrl(url, { state: { originalEventType: eventType } }).then(x => {
            this.communicationService.emitChangeToSkipNavLink(url);
        });
    }
}
